/* RESPONSIBLE TEAM: team-pricing-and-packaging */
import ApplicationAdapter from '../../application';

export default class UpcomingInvoiceAdaptor extends ApplicationAdapter {
  pathForType() {
    return 'invoices/upcoming';
  }
}
